import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SafetyAuthEditCheckedInput from './SafetyAuthEditCheckedInput';
import { AuthEditContentContainer } from './AuthEditMain.css';

const AuthEditHeader = ({ saftyAuths, manageTargetAuth, register }) => {
  const [manageTargetAuths, setManageTargetAuths] = useState([]);

  useEffect(() => {
    setManageTargetAuths(manageTargetAuth.split(','));
  }, [manageTargetAuth]);

  return (
    <AuthEditContentContainer>
      {saftyAuths.map((auth) => {
        return (
          <div className="factory-auth-check-box">
            <SafetyAuthEditCheckedInput
              register={register}
              authIdx={auth.authIdx}
              authNm={auth.authNm}
              trigger={manageTargetAuths.findIndex((x) => Number(x) === auth.authIdx) !== -1}
            />
          </div>
        );
      })}
    </AuthEditContentContainer>
  );
};

export default AuthEditHeader;
